import { render, staticRenderFns } from "./CommutatorGauge.vue?vue&type=template&id=edf1b81c&scoped=true&"
import script from "./CommutatorGauge.vue?vue&type=script&lang=js&"
export * from "./CommutatorGauge.vue?vue&type=script&lang=js&"
import style0 from "./CommutatorGauge.vue?vue&type=style&index=0&id=edf1b81c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf1b81c",
  null
  
)

export default component.exports